import React, { useState } from "react";
import { toast } from "sonner";
import { useRepMode } from "./RepModeContext";
import { EMPTY_VALUE, mailtoFor } from "../../ForCoaches/v2/coachUtils";
import { BmModal, Btn, Overline } from "../../ForBrands/ui/BrandUI";

// "Your Rep ID": the code a rep got at signup. Athletes enter it in
// My Circle (Add to my Circle, then Link a rep by ID) to link the rep.

const RepIdModal = () => {
  const { me, sharing, closeShare } = useRepMode();
  const [copied, setCopied] = useState(false);
  if (!sharing) return null;

  const code = me.repCode || "";
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      toast.error("Copy failed. Select the code and copy it manually.");
    }
  };
  const email = () => {
    window.location.href = mailtoFor({
      subject: "Link me as your rep on CACHE",
      body: `Hi,\n\nOpen My Circle in CACHE, choose Add to my Circle, then Link a rep by ID and enter my Rep ID:\n\n${code}\n\nYou decide what I can see. Deal status and timelines are shared; offer amounts stay private unless you turn on financial terms for me.\n\nThanks,\n${me.firstName || ""} ${me.lastName || ""}`.trim(),
    });
  };

  return (
    <BmModal
      title="Your Rep ID"
      onClose={closeShare}
      width={520}
      footer={
        <>
          <Btn onClick={copy}>{copied ? "Copied" : "Copy Rep ID"}</Btn>
          <Btn variant="secondary" onClick={email}>
            Send by email
          </Btn>
        </>
      }
    >
      <div className="flex flex-col gap-4">
        <div className="flex flex-col items-center gap-2 rounded-[12px] border border-bm-border bg-bm-subtle px-6 py-6">
          <Overline>Rep ID</Overline>
          <div className="font-archivo text-[34px] font-bold leading-none tracking-[0.06em] text-bm-ink" data-testid="rep-code">
            {code || EMPTY_VALUE}
          </div>
          {me.agency && <div className="bm-body-s text-bm-muted">{me.agency}</div>}
        </div>
        <p className="bm-body-m text-bm-muted">
          Athletes add you from My Circle with this ID, no email needed. Once linked, their deal status, compliance flags, guardian linkage and
          scores show up here.
        </p>
        <p className="bm-body-s text-bm-tertiary">Financial terms stay between the athlete and the brand unless the athlete turns them on for you.</p>
      </div>
    </BmModal>
  );
};

export default RepIdModal;
